import { getVisitExternalAnswers } from './api';

/** `source key -> qid -> answer`, resolved server-side for one visit. */
export type ExternalAnswerMap = Record<string, Record<string, string>>;

/**
 * Answers from other documents for a visit's `external-answer` layout nodes.
 *
 * Read-only. Nothing here is ever saved back onto the visit — the values belong
 * to the source document (today, the episode's Aide Care Plan).
 *
 * The generated response types the values as `unknown` because the route returns
 * a free-form map, so the cast is where that widening is absorbed. The resolver
 * flattens every answer to a string before it reaches the wire.
 */
export async function fetchVisitExternalAnswers(
  visitId: string
): Promise<ExternalAnswerMap> {
  const res = await getVisitExternalAnswers({
    path: { visit_id: visitId },
  });
  return (res.data as ExternalAnswerMap | undefined) ?? {};
}
